<mb-loading-bar></mb-loading-bar>
@if (authenticationService.isAuthenticated()) {
  <app-header></app-header>
}
@if (carouselService.isVisible) {
  <dis-news-carousel></dis-news-carousel>
}

<div class="container-wide">
  <div style="margin-top: 18px">
    <mb-breadcrumbs></mb-breadcrumbs>
  </div>
  <div style="margin-top: 18px">
    <router-outlet></router-outlet>
  </div>
</div>
